__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.9.4-cf9544e-17719/_next/";